import React from 'react';
import { AppPostInit as AppPostInitCore } from 'js/components/system/App/components/AppPostInit/AppPostInit';

import { useUserVerificationStatus } from './hooks';

export const AppPostInit = () => {
    useUserVerificationStatus();

    return <AppPostInitCore />;
};
